"use client";

import React, { useState } from "react";
import Link from "next/link";

export default function WheelerTabs({ highData, lowData, error, tabs, anchorPrefix = "Bike rental in" }) {
  const [activeTab, setActiveTab] = useState("nearby");

  const tabBase =
    "pb-2 text-base font-medium cursor-pointer transition-colors duration-300 bg-transparent border-0 border-b-2 border-transparent font-[inherit]";
  const tabActive =
    "text-[var(--color-accent-teal)] font-semibold border-[var(--color-text-primary)]";
  const tabInactive = "text-[var(--color-text-muted)]";

  const gridClasses =
    "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-3 gap-x-6 md:gap-x-8 lg:gap-x-10 mt-4 xl:max-w-[1200px] items-start";

  return (
    <>
      <div
        className="flex gap-8 mb-8 border-b border-[var(--color-text-muted)] text-left justify-start"
        role="tablist"
      >
        {tabs.map((tab) => (
          <button
            type="button"
            role="tab"
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`${tabBase} ${activeTab === tab.key ? tabActive : tabInactive}`}
            aria-selected={activeTab === tab.key}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {error ? (
        <p className="text-base text-[var(--color-text-muted)] text-center">
          {error} <button onClick={() => window.location.reload()}>Retry</button>
        </p>
      ) : (
        <>
          <div
            className={gridClasses}
            style={{ display: activeTab === "nearby" ? "grid" : "none" }}
            aria-hidden={activeTab !== "nearby"}
          >
            {highData.length > 0 ? (
              highData.map((destination, index) => (
                <div key={index} className="font-medium text-[var(--color-text-primary)] text-left">
                  <Link href={`/${destination.slug}`} passHref>
                    <p className="text-base text-[var(--color-text-primary)] transition-colors duration-300 hover:text-[var(--color-accent-teal)] hover:underline hover:cursor-pointer">{anchorPrefix} {destination.name}</p>
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-base text-[var(--color-text-muted)] text-center">No locations available</p>
            )}
          </div>

          <div
            className={gridClasses}
            style={{ display: activeTab === "other" ? "grid" : "none" }}
            aria-hidden={activeTab !== "other"}
          >
            {lowData.length > 0 ? (
              lowData.map((destination, index) => (
                <div key={index} className="font-medium text-[var(--color-text-primary)] text-left">
                  <Link href={`/${destination.slug}`} passHref>
                    <p className="text-base text-[var(--color-text-primary)] transition-colors duration-300 hover:text-[var(--color-accent-teal)] hover:underline hover:cursor-pointer">{anchorPrefix} {destination.name}</p>
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-base text-[var(--color-text-muted)] text-center">No locations available</p>
            )}
          </div>
        </>
      )}
    </>
  );
}
